<template>
  <fts-dropdown-select
    append-to-body
    prevent-overflow-alt-axis
    prevent-overflow-tether-off
    append-toggle-class="assign-date-toggle"
    content-class="dropdown-menu assign-date-dropdown-menu"
    :reference-for="referenceFor"
    overlay
    class="fts-assign-date"
    @show="onShow"
  >
    <slot slot="toggle">
      <div
        class="assign-date-toggle-label"
        :class="{'assign-date-toggle-label--due': overdue}"
        v-if="dueDate"
      >
        {{moment(dueDate).format('ll')}}
      </div>
      <div class="assign-date-toggle-label assign-date-toggle-label--blank" v-else>
        add due date
      </div>
    </slot>
    <template #menu="{ select }">
      <div class="assign-date-content">
        <div class="assign-date-shortcut">
          <div
            class="assign-date-shortcut-option"
            :class="{ 'shortcut-option--active': selectedShortcutOption(x.endDate) }"
            v-for="x in dateShortcuts"
            :key="x.id"
            @click="mutableDueDate = x.endDate"
          >
            {{x.label}}
          </div>
        </div>

        <VueCtkDateTimePicker
          :min-date="moment().startOf('day').format()"
          no-header
          no-button
          inline
          only-date
          format="llll"
          color="var(--fts-primary)"
          v-model="mutableDueDate"
          class="v-ctk-date-time-picker"
          ref="ctkDateTimePicker"
        />
      </div>
      <div class="assign-date-footer" @click="mutableDueDate=null;select();">
        <fts-btn
          text
          text-transform-init
          class="assign-date-action"
        >
          Clear
        </fts-btn>
      </div>
    </template>
  </fts-dropdown-select>
</template>

<script>
import moment from 'moment';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import commons from '../commons/commons';

import FTSBtn from './FTSBtn';
import FTSDropdownSelect from './FTSDropdownSelect';

export default {
  components: {
    VueCtkDateTimePicker,
    'fts-btn': FTSBtn,
    'fts-dropdown-select': FTSDropdownSelect,
  },
  props: {
    dueDate: [Date, Object, String],
    referenceFor: String
  },
  model: {
    prop: "dueDate",
    event: "updateDueDate",
  },
  methods: {
    moment,
    onShow() {
      try {
        let el = this.$refs.ctkDateTimePicker && this.$refs.ctkDateTimePicker.$children[0].$children[0];
        el && window.removeEventListener("keydown", el.keyPressed);
      } catch(err) {
        console.warn(err);
      }
    },
    selectedShortcutOption(val) {
      return this.dueDate && moment(this.dueDate).format('l') === moment(val).format('l');
    }
  },
  computed: {
    mutableDueDate: {
      get() {
        return this.dueDate && moment(this.dueDate).endOf('day');
      },
      set(val) {
        if (val) {
          this.$emit("updateDueDate", moment(val).endOf('day'));
        } else {
          this.$emit("updateDueDate", null);
        }
      }
    },
    overdue() {
      return this.dueDate && moment(this.dueDate).isBefore(moment().startOf('day'));
    }
  },
  created() {
    this.dateShortcuts = commons.taskDueDateShortcuts;
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-assign-date {
  .assign-date-toggle {
    display: flex;
  }
  .assign-date-toggle-label {
    border-top: 1px solid transparent;
    border-bottom: 1px solid var(--fts-border);
    font-size: 0.875rem;
    color: var(--fts-text);
    &.assign-date-toggle-label--due {
      color: var(--fts-danger);
    }
    &.assign-date-toggle-label--blank {
      color: var(--fts-default);
    }
  }
}
.assign-date-dropdown-menu {
  .assign-date-content {
    display: flex;
  }
  .assign-date-footer {
    padding: 0.5rem 0.5rem 0.25rem;
    border-top: 1px solid var(--fts-border);
    text-align: right;
    .assign-date-action {
      min-height: 1.875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
  .assign-date-shortcut {
    display: flex;
    flex-direction: column;
    margin-top: 0.75rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    .assign-date-shortcut-option {
      @include text-overflow-ellipsis;
      @include user-select-none;
      margin-bottom: 0.25rem;
      padding: 0.375rem;
      border-radius: 0.25rem;
      color: var(--fts-default);
      text-align: center;
      font-size: 0.75rem;
      line-height: 1rem;
      cursor: pointer;
      &:hover {
        background-color: var(--fts-gray-100);
      }
      &.shortcut-option--active {
        @include theme() {
          background: rgba(theme-get('fts-primary'), 0.095);
        }
        color: var(--fts-primary);
      }
    }
  }
}
</style>